module.exports = __webpack_public_path__ + "img/quest_edited.41aa5ffc.svg";